import Layout from "../components/Layout";
import TestCard from "../components/TestCard";

function TestPage(props) {
    return (
        <Layout>
            <TestCard/>
        </Layout>
    );
}

export default TestPage;